import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import AssessmentStateManager from "components/navigation/AssessmentStateManager";
import NotFound from "pages/NotFound";
import EmailCapture from './pages/email-capture';
import PersonalizedResults from './pages/personalized-results';
import LandingPage from './pages/landing-page';
import QuestionAssessment from './pages/question-assessment';
import PreAssessmentPreparation from './pages/pre-assessment-preparation';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <AssessmentStateManager>
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/email-capture" element={<EmailCapture />} />
        <Route path="/personalized-results" element={<PersonalizedResults />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/pre-assessment-preparation" element={<PreAssessmentPreparation />} />
        <Route path="/question-assessment" element={<QuestionAssessment />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </AssessmentStateManager>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
